<script>
	// NPM Modules
	import dayjs from 'dayjs';
	// Stores
	import SelectionStore from '@/Stores/Racing/SelectionStore.js';
	// Components
	import TextInput from '@/Components/TextInput.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let selection;
	export let race;

	let win = selection.deductions && selection.deductions.win ? selection.deductions.win : 0;
	let place = selection.deductions && selection.deductions.place ? selection.deductions.place : 0;

	function onSave() {
		SelectionStore.updateDeductions(selection.id, {
			deductions: { win, place }
		})
			.then(() => {
				notify({
					type: 'success',
					title: 'Deductions updated',
					message: `Selection [${selection.number}. ${selection.name}] updated.`,
					timeout: 3
				});
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Deductions updated',
					message: (e.error && e.error[0]) || 'Failed to update deductions',
					timeout: 5
				});
			});
	}
</script>

<div class="table-row hover:bg-gray-200">
	<div class="table-cell py-2 border-b border-row-separator">
		<div class="inline font-semibold">{selection.number}. {selection.name}</div>
		<div class="inline ml-1 text-sm">
			{selection.scratched_time ? '@ ' + dayjs(selection.scratched_time).format('HH:mm D/MM/YY') : 'N/A'}
		</div>
	</div>
	<div class="table-cell py-2 border-b border-row-separator">
		<div class="flex justify-end">
			<div class="flex w-1/2">
				<div class="flex items-center">
					Win:
					<TextInput disabled={!race.in_review} name="win-{selection.number}" bind:value={win} className="mx-1" />
				</div>
				<div class="flex items-center">
					Place:
					<TextInput disabled={!race.in_review} name="place-{selection.number}" bind:value={place} className="mx-1" />
				</div>
				<button
					disabled={!race.in_review}
					on:click={onSave}
					class="p-2 my-1 ml-2 text-white {race.in_review ? 'bg-black' : 'bg-gray-400'}
          rounded-md"
				>
					Save
				</button>
			</div>
		</div>
	</div>
</div>
